const GameClosed = ({ gameState }) => {
  return (
    <div className="game-closed">
      <h1>Whoopsie!</h1>
      <p className="error-subtitle">Er is iets fout gegaan</p>
      <p className="error-subtitle">Probeer deze pagina te herladen...</p>
    </div>
  );
};

export default GameClosed;
